/**
 * This is a Nuxt route guard that manages authentication-based navigation.
 * The .global suffix makes this middleware run on every route change.
 * See https://nuxt.com/docs/guide/directory-structure/middleware
 */

const publicPages = [
  '/', 
  '/login', 
  '/demo', 
  '/contact',
  '/faqs',
  '/legal'
];

// noinspection JSUnusedGlobalSymbols
export default defineNuxtRouteMiddleware((to, _from) => {
  // Check if the current path is a public page
  const isPublicPage = publicPages.some(page => to.path.startsWith(page));
  
  // If it's not a public page and it was not a browser refresh and the user is not authenticated, redirect to /login
  if (!isPublicPage && typeof window !== 'undefined' && !useAuth().isAuthenticated()) {
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  }
});
